import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { AiOutlineHome, AiOutlineUser, AiOutlineMail } from "react-icons/ai";
import { FaRegFolder } from "react-icons/fa";

// Navbar container styling
const NavbarContainer = styled.div`
  background-color: #c770f0;
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 50px;
  max-width: 600px;
  border-radius: 50px;
  box-shadow: 0 8px 15px rgba(217, 209, 218, 0.53);
  padding: 5px 10px; // Further reduced padding for a smaller height
  display: flex;
  justify-content: space-around;
  align-items: center; // Keeps the icons centered vertically
  z-index: 1000;

  @media (max-width: 768px) {
    height: 40px; 
    padding: 30px 10px; // Adjust padding for mobile devices
  }
`;

// Styling for individual NavItems
const NavItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  color: ${(props) =>
    props.active
      ? "rgb(255, 255, 255)"
      : "inherit"}; // Highlight color for active item
  background-color: ${(props) =>
    props.active ? "#b652f0" : "transparent"}; // Background for active item
  border-radius: 50px; // Rounded effect for active item
  padding: 7px 20px; // Adjust padding for better visual appearance

  &:hover {
    color: rgb(255, 255, 255); // Hover color for text and icon
  }

  svg {
    margin-bottom: 3px; // Reduced margin for smaller icons
    z-index: 1;
  }

  @media (max-width: 768px) {
    font-size: 1.9rem; // Icon size for mobile
    span {
      display: none; // Hide text on mobile
    }
  }
`;

// Remove underline from the link and ensure font consistency
const StyledLink = styled(Link)`
  text-decoration: none; // Removes underline
  font-family: inherit; // Inherit the font from the app (this assumes the app has a global font set)
  color: inherit; // Inherit color from the parent, so hover color works
`;

function NavBar() {
  // State to track the active item
  const [active, setActive] = useState("home");

  // Handle click to set active item
  const handleItemClick = (item) => {
    setActive(item);
  };

  return (
    <NavbarContainer>
      <NavItem
        active={active === "home"}
        onClick={() => handleItemClick("home")}
      >
        <StyledLink to="/">
          <AiOutlineHome />
          <span> Home</span>
        </StyledLink>
      </NavItem>

      <NavItem
        active={active === "about"}
        onClick={() => handleItemClick("about")}
      >
        <StyledLink to="/about">
          <AiOutlineUser />
          <span> About</span>
        </StyledLink>
      </NavItem>

      <NavItem
        active={active === "projects"}
        onClick={() => handleItemClick("projects")}
      >
        <StyledLink to="/SomeProjects">
          <FaRegFolder />
          <span> Some Projects</span>
        </StyledLink>
      </NavItem>

      <NavItem
        active={active === "contact"}
        onClick={() => handleItemClick("contact")}
      >
        <StyledLink to="/contactUs">
          <AiOutlineMail />
          <span> Contact</span>
        </StyledLink>
      </NavItem>
    </NavbarContainer>
  );
}

export default NavBar;
